export const timeSlots = [{
  label: '08:00 – 09:00',
  value: '08:00 - 09:00',
},
{
  label: '09:00 – 10:00',
  value: '09:00 - 10:00',
},
{
  label: '10:00 – 11:00',
  value: '10:00 - 11:00',
},
{
  label: '11:00 – 12:00',
  value: '11:00 - 12:00',
},
{
  label: '12:00 – 13:00',
  value: '12:00 - 13:00',
},
{
  label: '13:00 – 14:00',
  value: '13:00 - 14:00',
},
{
  label: '14:00 – 15:00',
  value: '14:00 - 15:00',
},
{
  label: '15:00 – 16:00',
  value: '15:00 - 16:00',
},
{
  label: '16:00 – 17:00',
  value: '16:00 - 17:00',
},
{
  label: '17:00 – 18:00',
  value: '17:00 - 18:00',
}];
